<template>
  <div class="statistics">
    <div class="tabs-bar">
      <div class="bar-wrap">
        <div :class="['tab', active === 0 ? 'active' : '']" @click="active = 0">
          初评
        </div>
        <div :class="['tab', active === 1 ? 'active' : '']" @click="active = 1">
          终评
        </div>
      </div>
    </div>
    <div class="search">
      <div class="search-input">
        <el-input
          placeholder="搜索作品名称、编号"
          v-model="worksName"
          @keydown.enter.native="getPageList(true)"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div :class="['filter', active ? 'ed' : '']">
        <div
          v-if="active === 0"
          :class="['timer', remarkSign === 2 ? 'checked' : '']"
          @click="remarkSign = 2"
        >
          待补充
        </div>
        <div
          :class="['timer', remarkSign === 0 ? 'checked' : '']"
          @click="remarkSign = 0"
        >
          <span>{{ active ? "已入围" : "点评中" }}</span>
        </div>
        <div
          :class="['condition', remarkSign === 1 ? 'checked' : '']"
          @click="remarkSign = 1"
        >
          {{ active ? "已获奖" : "已评完" }}
        </div>
      </div>
      <!-- <div class="search-btn" @click="getPageList(true)">搜索</div> -->
    </div>
    <!-- <div class="filter">
      <div
        :class="['timer', remarkSign === 0 ? 'checked' : '']"
        @click="remarkSign = 0"
      >
        <span>{{ active ? "已入围" : "点评中" }}</span>
      </div>
      <div
        :class="['condition', remarkSign === 1 ? 'checked' : '']"
        @click="remarkSign = 1"
      >
        {{ active ? "已获奖" : "已评完" }}
      </div>
    </div> -->

    <div class="works-list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="works-item"
          v-for="(item, i) in dataList"
          :key="i"
          @click="toPhotoDetail(item)"
        >
          <div class="works-img">
            <img v-setshow :src="item.img" alt="" />
            <div
              class="view-ccie"
              v-if="active === 1 && remarkSign === 1"
              @click.stop="viewCcie(item)"
            >
              查看证书
            </div>
          </div>
          <div class="works-infos">
            <div class="works-tit">
              <div class="tit-infos">
                <div class="works-title">{{ item.title }}</div>
                <div
                  class="slogan"
                  @click.stop="(showSlogan = true), (content = item.slogan)"
                >
                  <div>{{ item.slogan }}</div>
                </div>
              </div>
            </div>
            <div class="author-info">
              <div class="author">
                <p>
                  {{ `${item.author} | ${item.majorName} | ${item.groupName}` }}
                </p>
                <!-- <p>报名服务单位：{{ item.organization }}</p> -->
                <p>上传：{{ item.time }}</p>
              </div>
              <div class="remark-area">
                <div class="btn" v-if="active === 0">
                  {{
                    item.typeSub === 1
                      ? "待补充"
                      : remarkSign === 0
                      ? item.commentNum
                        ? `${item.commentNum}位点评`
                        : "待点评"
                      : `${item.commentNum}位点评`
                  }}
                </div>
                <div class="btn" v-else>
                  {{ remarkSign === 0 ? "决赛中" : item.prizeStr }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-image-preview v-model="show" :images="images" @click="show = false">
      <template #cover>
        <div class="apply-ccie-btn" v-if="canApply">
          <van-button
            :disabled="!isAudit"
            size="large"
            @click.stop="applyCcie"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            >申请纸质证书</van-button
          >
        </div>
        <div class="pre-close" style="text-align: right">
          <van-icon
            @click="show = false"
            name="close"
            :style="{
              margin: '10px',
              fontSize: '24px',
              color: '#fff',
              position: 'fixed',
              left: '10px',
              right: '10px'
            }"
          />
        </div>
      </template>
    </van-image-preview>
    <van-dialog
      v-model="showAddressInp"
      title="请填写寄送地址以便于邮寄证书"
      show-cancel-button
      @confirm="applyCcie"
      @cancel="show = false"
    >
      <textarea
        class="address-inp"
        placeholder="请输入邮寄地址"
        maxlength="64"
        v-model="addressStr"
      ></textarea>
      <span>{{ addressStr.length }} / 64</span>
    </van-dialog>
    <!-- 简介信息 -->
    <van-popup
      v-model="showSlogan"
      class="slogan"
      closeable
      close-icon="arrow-down"
      close-icon-position="top-right"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="info-wrap">
        <div class="intro" v-html="content"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getPageInstitutionWorks } from "@/utils/api/org";
import { getWorksCertificate, applyCert } from "@/utils/api/user";
export default {
  watch: {
    active: function (v) {
      this.page = 1;
      this.finished = false;
      this.worksName = "";
      if (!v) {
        this.remarkSign = 2;
      } else {
        this.remarkSign = 0;
      }
      this.getPageList(true);
    },
    remarkSign: function () {
      this.page = 1;
      this.finished = false;
      this.worksName = "";
      this.getPageList(true);
    }
  },
  data() {
    return {
      // 0决赛 1初赛
      active: 0,
      // 标记
      remarkSign: 2,
      // 搜索名称
      worksName: "",
      // 数据列表
      dataList: [],
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      // 查看证书
      show: false,
      //
      showAddressInp: false,
      // 证书
      images: [],
      // 地址
      addressStr: "",
      canApply: false,
      isAudit: false,
      showSlogan: false,
      content: ""
    };
  },
  methods: {
    toPhotoDetail(item) {
      if (item.typeSub) {
        this.$router.push({
          path: "/replenishinfo",
          query: {
            id: item.id,
            mode: 1
          }
        });
        this.$notify({
          type: "danger",
          message: "请先补充作品信息"
        });
        return;
      }
      this.$root.mipLink("/player/photodetail", { id: item.id });
    },
    onLoad() {
      this.page++;
      this.getPageList(this.page === 1);
    },
    // 查看证书
    viewCcie(item) {
      getWorksCertificate(item.id).then((res) => {
        if (res.success) {
          this.show = true;
          this.chickId = item.id;
          this.images = [res.data.certUrl];
          this.canApply = res.data.isApply;
          this.isAudit = res.data.isAudit;
        }
      });
    },
    // 申请证书
    applyCcie() {
      // if (!this.addressStr) {
      //   this.$toast.fail("地址信息不可为空");
      //   return;
      // }
      const id = this.chickId;
      // const str = this.addressStr;
      applyCert({ id }).then((res) => {
        if (res.success) {
          this.$toast.success("申请成功！");
          this.show = false;
          // this.showAddressInp = false;
        }
      });
    },
    // 加载列表
    getPageList(init = false) {
      this.loading = true;
      const p = {
        pageNo: this.page,
        pageSize: this.pageSize,
        name: this.worksName,
        typeId: this.active,
        typeSub: this.remarkSign
      };
      if (!this.worksName) {
        delete p.name;
      }
      getPageInstitutionWorks(p).then((res) => {
        if (res.success) {
          if (init) this.dataList = [];
          const loadData = res.data.records.map((e) => {
            return {
              id: e.id,
              img: e.imgs,
              title: e.name,
              author: e.babyName,
              organization: e.institutionName || "暂无报名服务单位",
              time: e.addTime,
              majorName: e.majorName,
              groupName: e.groupName,
              slogan: e.synopsis,
              commentNum: e.commentNum,
              typeSub: e.typeSub,
              prizeStr: e.grandPrize
                ? "特等奖"
                : e.prize == 1
                ? "一等奖"
                : e.prize == 2
                ? "二等奖"
                : e.prize == 3
                ? "三等奖"
                : e.prize == 4
                ? "优秀奖"
                : "谢谢参与"
            };
          });
          this.dataList.push(...loadData);
        } else {
          this.finished = true;
          this.loading = false;
        }
        this.loading = false;
        if (this.page * this.pageSize >= res.data.total) {
          this.finished = true;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.statistics {
  display: flex;
  flex-direction: column;
  text-align: left;
  height: calc(100vh - 75px);
  .tabs-bar {
    position: fixed;
    top: 0;
    left: 0px;
    width: 375px;
    height: 52px;
    border-bottom: 1px solid #f2f2f2;
    background: #ffffff;
    box-shadow: 0px 3px 5px rgba(108, 221, 143, 0.26);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    z-index: 20;
    .bar-wrap {
      width: 100%;
      height: 30px;
      border-radius: 15px;
      display: flex;
      overflow: hidden;
      .tab {
        width: 50%;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        color: #054b1b33;
        font-weight: bold;
        &.active {
          color: #6cdd8f;
          &::after {
            content: "";
            height: 2px;
            width: 32px;
            position: absolute;
            bottom: 0;
            left: calc((100% - 32px) / 2);
            background-color: #6cdd8f;
          }
        }
      }
    }
  }

  .search {
    width: 335px;
    height: 50px;
    margin: 0 auto;
    margin-top: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .search-input {
      width: 50%;
      height: 30px;
      flex: 1;
    }
    .search-btn {
      flex: 1;
      height: 30px;
      justify-content: center;
      display: flex;
      align-items: center;
    }
    .filter {
      width: 150px;
      height: 30px;
      display: flex;
      justify-content: space-around;
      border-radius: 16px;
      border: 1px solid #6cdd8f;
      overflow: hidden;
      margin-left: 15px;
      &.ed {
        & > div {
          width: 50%;
        }
      }
      & > div {
        width: 33.33%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        color: #6cdd8f;
        &.checked {
          // position: relative;
          color: #fff;
          background: #6cdd8f;
          // &::after {
          //   content: "";
          //   width: 100%;
          //   height: 2px;
          //   background-color: #16d77a;
          //   position: absolute;
          //   bottom: 0;
          //   left: 0;
          // }
        }
        &:not(.checked) {
          .sort-ico {
            i:last-child {
              margin-top: -7px;
            }
          }
        }
      }
      .timer {
        span {
        }
        .sort-ico {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 6px;
          height: 100%;
          margin-left: 2px;
        }
      }
      .condition {
      }
    }
  }
  & > .filter {
    height: 50px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    & > div {
      width: 45%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #999999;
      height: 50px;
      &.checked {
        position: relative;
        color: #16d77a;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-color: #16d77a;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
      &:not(.checked) {
        .sort-ico {
          i:last-child {
            margin-top: -7px;
          }
        }
      }
    }
    .timer {
      span {
      }
      .sort-ico {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 6px;
        height: 100%;
        margin-left: 2px;
      }
    }
    .condition {
    }
  }
  .condition-filter {
    height: 100%;
    width: 100%;
    .cond-lst {
      padding: 0 10px;
      .major-lst,
      .group-lst {
        display: flex;
        flex-wrap: wrap;

        .major,
        .group {
          margin-left: 10px;
          margin-bottom: 10px;
          background-color: #f9f9f9;
          border-radius: 3px;
          text-align: center;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          color: #999;
          min-width: 50px;
          padding: 0 10px;
          &.selected {
            border: 1px solid #2ccf79;
            color: #2ccf79;
            background-color: #fff;
          }
        }
      }
    }
    .cond-handle {
      height: 40px;
      display: flex;
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      & > div {
        height: 100%;
        width: 50%;
        text-align: center;
        line-height: 40px;
        font-size: 13px;
      }
      .reset {
        color: #1abc9c;
        border-top: 1px solid #f2f2f2;
      }
      .confirm {
        color: #fff;
        background-color: #21c365;
      }
    }
  }
  .works-list {
    flex: 1;
    overflow-y: scroll;
    .works-item {
      position: relative;
      height: 145px;
      width: 100%;
      padding: 15px 20px;
      display: flex;
      .works-img {
        width: 84px;
        height: 115px;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        background: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 100%;
        }
        .view-ccie {
          height: 40px;
          width: 120px;
          font-size: 20px;
          position: absolute;
          bottom: 0px;
          left: -18px;
          border-radius: 20px;
          line-height: 40px;
          transform: scale(0.5);
          text-align: center;
          color: #fff;

          background: linear-gradient(90deg, #5dd68288 0%, #5aff8e88 100%);
        }
      }
      .works-infos {
        position: relative;
        flex: 1;
        margin-left: 8px;
        display: flex;
        flex-direction: column;
        .works-tit {
          position: relative;
          border-bottom: 1px solid #f9f9f9;
          height: 43px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          max-width: 240px;
          .tit-infos {
            * {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            .works-title {
              font-size: 14px;
              font-weight: 700;
              color: #666;
            }

            .slogan {
              width: 100%;
              position: relative;
              div {
                font-size: 12px;
                margin: 5px 0;
                color: #999;
                line-height: 20px;
                max-width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              &::before {
                content: "";
                position: absolute;
                z-index: 1;
                height: 100%;
                width: 10px;
                display: block;
                background: url("../../assets/images/active/icon-right-arr.png");
                background-size: 10px 10px;
                background-position: center center;
                background-repeat: no-repeat;
                top: 0;
                right: 15px;
              }
            }
          }
        }
        .author-info {
          position: relative;
          display: flex;
          justify-content: space-between;
          .author {
            font-size: 12px;
            color: #666;
            max-width: 160px;
            p {
              max-width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              line-height: 24px;
              &:first-child {
                color: #fedc01;
              }
            }
          }
          .remark-area {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            .btn {
              width: 57px;
              height: 20px;
              border-radius: 5px;
              color: #fff;
              text-align: center;
              background: linear-gradient(90deg, #5dd682 0%, #5aff8e 100%);
              opacity: 1;
              border-radius: 11px;
              line-height: 21px;
            }
            .judge {
              display: flex;
              justify-content: flex-end;
              flex-direction: row-reverse;
              margin-top: 10px;
              img {
                width: 15px;
                height: 15px;
                border-radius: 50%;
              }
              i {
                font-size: 15px;
              }
            }
          }
        }
      }
    }
  }
  .apply-ccie-btn {
    position: fixed;
    height: 52px;
    bottom: 0px;
    width: 254px;
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>

<style lang="scss">
.statistics {
  .search-input {
    .el-input {
      display: flex;
      align-items: center;
      width: 180px;
      .el-input__icon {
        line-height: 32px;
      }
      input {
        background-color: #f2f2f2;
        height: 30px;
        line-height: 30px;
        border-radius: 20px;
        border: none;
      }
    }
  }
  .van-image-preview {
    .van-image {
      padding: 0 20px;
      img {
        max-width: 335px;
      }
    }
    .van-image-preview__cover {
      .apply-ccie-btn {
        position: fixed;
        bottom: 20px;
        left: 60px;
      }
    }
  }
  .van-dialog__content {
    margin-top: 10px;
    position: relative;
    textarea {
      resize: none;
      width: 256px;
      height: 110px;
      margin: 0 auto;
      display: block;
    }
    span {
      position: absolute;
      display: block;
      bottom: 5px;
      right: 35px;
    }
  }
  .van-popup.slogan {
    border-radius: 20px 20px 0 0;
    overflow-y: hidden;
    .van-icon {
      right: calc((100% - 16px) / 2);
      font-size: 16px;
      &::after {
        content: "";
        position: absolute;
        left: -3px;
        top: -3px;
        height: 20px;
        width: 20px;
        box-sizing: content-box;
        border: 1px solid #c8c9cc;
        border-radius: 50%;
      }
    }
  }
  .info-wrap {
    margin-top: 50px;
    padding: 0 20px;
    height: 100%;
    overflow-y: scroll;
    .intro {
      margin-top: 20px;
      line-height: 24px;
      font-size: 14px;
      color: #999;
      padding-bottom: 80px;
    }
  }
}
</style>
